var React = require('react');

function Phone (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.544,21.811A33.664,33.664,0,0,0,27.189,36.456l4.889-4.889a2.209,2.209,0,0,1,2.267-.533A25.349,25.349,0,0,0,42.278,32.3,2.229,2.229,0,0,1,44.5,34.522v7.756A2.229,2.229,0,0,1,42.278,44.5,37.774,37.774,0,0,1,4.5,6.722,2.229,2.229,0,0,1,6.722,4.5H14.5a2.229,2.229,0,0,1,2.222,2.222,25.245,25.245,0,0,0,1.267,7.933,2.23,2.23,0,0,1-.556,2.267l-4.889,4.889Z","transform":"translate(-4.5 -4.5)","fill":"#3b3b3b"}));
}

Phone.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40"};

module.exports = Phone;

Phone.default = Phone;
